import React from "react";

const LogosSlider = ({ images }) => {
  return (
    <div
      className="flex flex-col lg:flex-row items-center space-y-8 lg:space-y-0 lg:space-x-8 py-12 bg-white"
      // style={{
      //   background:
      //     "linear-gradient(9deg, rgba(40, 75, 90, 0.20) -2.93%, rgba(89, 161, 193, 0.20) 93.32%)",
      // }}
    >
      <h2 className="text-4xl md:text-6xl lg:text-8xl font-bold w-full lg:w-1/2 ml-0 lg:ml-8 text-[#284b5a] text-center lg:text-left">
        Partners
      </h2>
      <div className="overflow-hidden relative w-full">
        <div className="w-full max-w-6xl mx-auto py-12">
          {/* Logos Section */}
          <div className="relative overflow-hidden py-8 whitespace-nowrap">
            {/* Left Gradient Overlay */}
            <div className="absolute top-0 left-0 w-16 md:w-32 h-full z-10 bg-gradient-to-r from-[white] via-transparent to-transparent"></div>

            {/* Sliding Logos */}
            <div className="inline-block animate-slide">
              {images.concat(images).map(({ src, alt }, index) => (
                <img
                  key={index}
                  src={src}
                  alt={alt}
                  className="h-16 md:h-20 mx-4 md:mx-6 inline-block"
                />
              ))}
            </div>

            {/* Right Gradient Overlay */}
            <div className="absolute top-0 right-0 w-16 md:w-32 h-full z-10 bg-gradient-to-l from-[white] via-transparent to-transparent"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogosSlider;
